import type { PageSpacing } from "@loot-os/api-contract";
import type { ReactNode } from "react";

import { cn } from "../../foundations/cn.js";

export interface SectionColumnProps {
  /** The top of the page, full bleed and outside the column's spacing: Home's hero. */
  lead: ReactNode;
  /** The sections below it, in order. */
  body: ReactNode;
  /** How far apart the sections sit: `roomy` a showroom's, `tight` an arcade's. */
  spacing: PageSpacing;
}

/**
 * A page drawn from a list of sections: the lead, then the rest down one column with the
 * list's spacing between them. Every page built from a list lays out through it, so a preset
 * is data (`sectionListTemplate`), never a layout component of its own.
 */
export function SectionColumn({ lead, body, spacing }: SectionColumnProps) {
  return (
    <>
      {lead}
      <div
        className={cn(
          "flex flex-col",
          spacing === "tight" ? "gap-10 pb-16 md:gap-14" : "gap-16 pb-20 md:gap-24",
        )}
      >
        {body}
      </div>
    </>
  );
}
